module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAAXNSR0IArs4c6QAAAExJREFUCB1jYEAFokAuCMMBC5zFwMADZMtC+d+B9BcQmwkqwAqklYCYEYpBbJAYAzMQgxSpAjEHEMMASBxk4jsQQw6IBYAYHbABBVgBRcIEAEminToAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/v2/sort-up.png
// module id = 176
// module chunks = 33